import { Controller } from "stimulus";
import $ from "jquery";

export default class extends Controller {

  static targets = ['userUnpairedDevices', 'devicesSelect', 'userSelect', 'clientContact', 'readingUnit', 'readingUnitNotice', 'tokenId', 'manufacturerSelect', 'manufacturerText', 'meterTypeSelect', 'meterTypeText', 'meterFlowSelect', 'meterFlowText', 'newDeviceNumber', 'newDeviceNumberNotice', 'nomUserId', 'nomDeviceId', 'readingUnitGroup', 'flxFields', 'flxInput', 'litersPerPulse', 'flxInputNotice', 'oldPhotoInput', 'oldPhotoPreview', 'oldPhotoData', 'newPhotoInput', 'newPhotoPreview', 'newPhotoData', 'rtxGroups', 'wmbusCheckbox', 'protocolId', 'oldPhotoLoading', 'newPhotoLoading', 'tookOverName', 'tookOverEmail', 'tookOverNotPresentButton', 'mapType', 'loadGps', 'latitude', 'longitude', 'customEmailCheckbox', 'customEmail', 'userSelect', 'companySelect', 'nomUserId'];

  initialize() {
    if (this.hasWmbusCheckboxTarget) {
      this.toggleWmbus();
      this.select2init();
    }

    if (this.hasCustomEmailCheckboxTarget) {
      this.toggleCustomEmailCheckbox();
    }

    this.toggleDeviceFlxFields();
    const initialFlxToken = this.hasMapTypeTarget && this.mapTypeTarget.getAttribute('flx_token') === 'true';
    this.toggleFlxConfiguration(initialFlxToken);

    this.initializeFileInputs();
  }

  reloadDevices() {
    const controller = this;

    $.ajax({
      // url: `/assembly_protocols/user_unpaired_devices.json`,
      url: `/assembly_protocols/user_unpaired_devices`,
      type: 'get',
      data: `nom_user_id=${this.userSelectTarget.value}`,
      success: function (response) {
        document.querySelector('#devices-accordion').innerHTML = response;
        controller.toggleDeviceFlxFields();
      }
    })
  }

  setUserDevices(data) {
    this.userUnpairedDevices(data)
    this.refreshDevicesSelectValues(data)
  }

  userUnpairedDevices(data) {
    this.userUnpairedDevicesTarget.innerHTML = ''

    data.forEach((device) => {
      const span = document.createElement("span");
      span.innerHTML = device.name;
      this.userUnpairedDevicesTarget.appendChild(span);
      this.userUnpairedDevicesTarget.appendChild(document.createElement("br"));

    });
  }

  refreshDevicesSelectValues(data) {
    this.devicesSelectTarget.innerHTML = "";

    const option = document.createElement("option");
    option.innerHTML = "----";
    this.devicesSelectTarget.appendChild(option);

    data.forEach((device) => {
      const option = document.createElement("option");
      option.value = device.id;
      option.innerHTML = device.name;
      this.devicesSelectTarget.appendChild(option);
    });
  }

  loadSerial(checkFlxInput = false) {
    if (this.lteMapType()) {
      return;
    }

    const controller = this;

    const inputParam = checkFlxInput === true ? `&input=${this.flxInputValue()}` : '';

    $.ajax({
      url: `/assembly_protocols/load_serial.json`,
      type: 'get',
      data: `serial=${this.newDeviceNumberTarget.value}&user_id=${this.nomUserIdTarget.value}&map_type=${this.mapTypeTarget.getAttribute('map_type')}&device_id=${this.nomDeviceIdValue()}${inputParam}`,
      success: function (response) {
        console.log(response)
        controller.toggleFlxConfiguration(response.flx_token)
        if (!response.not_available && controller.hasFlxInputNoticeTarget) {
          controller.flxInputNoticeTarget.classList.add('hidden')
        }
        const wmbusSerialAvailable = response.wmbus_serial && response.wmbus_serial !== ''
        controller.wmbusToggle(response, wmbusSerialAvailable)

        if (wmbusSerialAvailable) {
          controller.readingUnitTarget.value = '';
          controller.readingUnitGroupTarget.classList.add('hidden')
        }
        else {
          controller.tokenIdTarget.value = response.token_id
          if (response.not_available) {
            if (response.flx_token) {
              controller.flxInputNoticeTarget.classList.remove('hidden')
              controller.newDeviceNumberNoticeTarget.classList.add('hidden')
            }
            else {
              controller.newDeviceNumberNoticeTarget.classList.remove('hidden')
            }
            controller.readingUnitGroupTarget.classList.remove('hidden')
          }
          else if (response.token_id && response.token_id !== '') {
            controller.tokenIdToggle(response)
            controller.wmToggle(response)
          }
          else {
            controller.readingUnitGroupTarget.classList.remove('hidden')
            controller.newDeviceNumberNoticeTarget.classList.add('hidden')
          }
        }
      }
    })
  }

  flsNbMapType() {
    return this.hasMapTypeTarget && this.mapTypeTarget.getAttribute('map_type') === 'fls_nb'
  }

  flxMapType() {
    return this.hasMapTypeTarget && this.mapTypeTarget.getAttribute('map_type') === 'flx'
  }

  lteMapType() {
    return this.flsNbMapType() || this.flxMapType()
  }

  toggleDeviceFlxFields() {
    const selectedMap = this.element.querySelector('input[name="assembly_protocol[map_type]"]:checked');
    const flxSelected = selectedMap && selectedMap.value === this.element.dataset.flxMapValue;

    this.element.querySelectorAll('[data-flx-device-fields]').forEach((fields) => {
      fields.classList.toggle('hidden', !flxSelected);
    });
  }

  toggleFlxConfiguration(flxToken) {
    if (!this.hasFlxFieldsTarget) {
      return;
    }

    const visible = this.flxMapType() || flxToken === true;
    this.flxFieldsTarget.classList.toggle('hidden', !visible);

    if (!visible) {
      this.flxInputTarget.value = '';
      this.litersPerPulseTarget.value = '';
      this.flxInputNoticeTarget.classList.add('hidden');
    }
  }

  flxInputValue() {
    return this.hasFlxInputTarget ? this.flxInputTarget.value : '';
  }

  nomDeviceIdValue() {
    return this.hasNomDeviceIdTarget ? this.nomDeviceIdTarget.value : '';
  }

  showManufacturerTypeFlow() {
    this.manufacturerSelectTarget.value = '';
    this.manufacturerSelectTarget.classList.remove('hidden')
    this.manufacturerTextTarget.classList.add('hidden')
    this.meterTypeSelectTarget.value = '';
    this.meterTypeSelectTarget.classList.remove('hidden')
    this.meterTypeTextTarget.classList.add('hidden')
    this.meterFlowSelectTarget.value = '';
    this.meterFlowSelectTarget.classList.remove('hidden')
    this.meterFlowTextTarget.classList.add('hidden')
  }

  wmbusToggle(response, wmbusSerialAvailable) {
    if (response.not_fls_wm_type && wmbusSerialAvailable) {
      this.manufacturerTextTarget.classList.remove('hidden')
      this.manufacturerTextTarget.innerText = response.manufacturer
      this.meterTypeTextTarget.classList.remove('hidden')
      this.meterTypeTextTarget.innerText = response.meter_type
      this.meterFlowTextTarget.classList.remove('hidden')
      this.meterFlowTextTarget.innerText = response.meter_flow
      this.newDeviceNumberTarget.value = response.wmbus_serial
    }
    else if (this.hasTargetManufacturerSelect) {
      this.showManufacturerTypeFlow()
    }
  }

  tokenIdToggle(response) {
    this.tokenIdTarget.value = response.token_id
    this.readingUnitTarget.value = '';
    this.readingUnitGroupTarget.classList.add('hidden')
    this.newDeviceNumberNoticeTarget.classList.add('hidden')
  }

  flsNbTokenIdToggle(response) {
    this.tokenIdTarget.value = response.token_id
    this.newDeviceNumberNoticeTarget.classList.add('hidden')
    this.readingUnitNoticeTarget.classList.add('hidden')
    if (this.hasFlxInputNoticeTarget) {
      this.flxInputNoticeTarget.classList.add('hidden')
    }
    this.readingUnitGroupTarget.classList.remove('hidden')
  }

  wmToggle(response) {
    if (response.manufacturer_id && response.token_id !== '') {
      this.manufacturerSelectTarget.value = response.manufacturer_id
      this.refreshSelectValues(this.meterTypeSelectTarget, response.meter_type_data)
      this.meterTypeSelectTarget.value = response.meter_type_id
      this.refreshSelectValues(this.meterFlowSelectTarget, response.meter_flow_data)
      this.meterFlowSelectTarget.value = response.meter_flow_id
    }
    else {
      this.showManufacturerTypeFlow()
    }
  }

  loadTokenId(event) {
    const controller = this;
    const checkFlxInput = event && this.hasFlxInputTarget && event.currentTarget === this.flxInputTarget;

    if (checkFlxInput && !this.flxMapType() && this.readingUnitTarget.value === '') {
      this.loadSerial(true);
      return;
    }

    if (this.lteMapType()) {
      const mapType = this.mapTypeTarget.getAttribute('map_type');
      const deviceId = this.nomDeviceIdValue();
      const inputParam = checkFlxInput ? `&input=${this.flxInputValue()}` : '';

      $.ajax({
        url: `/assembly_protocols/load_serial.json`,
        type: 'get',
        data: `serial=${this.readingUnitTarget.value}&user_id=${this.nomUserIdTarget.value}&map_type=${mapType}&device_id=${deviceId}${inputParam}`,
        success: function (response) {
          controller.toggleFlxConfiguration(response.flx_token)
          if (response.not_available) {
            controller.tokenIdTarget.value = ''
            if (response.flx_token && controller.hasFlxInputNoticeTarget) {
              controller.flxInputNoticeTarget.classList.remove('hidden')
              controller.newDeviceNumberNoticeTarget.classList.add('hidden')
            }
            else {
              controller.newDeviceNumberNoticeTarget.classList.remove('hidden')
            }
            controller.readingUnitNoticeTarget.classList.add('hidden')
          }
          else if (response.token_id && response.token_id !== '') {
            controller.flsNbTokenIdToggle(response)
          }
          else if (controller.readingUnitTarget.value !== '') {
            controller.tokenIdTarget.value = ''
            controller.newDeviceNumberNoticeTarget.classList.add('hidden')
            if (controller.hasFlxInputNoticeTarget) {
              controller.flxInputNoticeTarget.classList.add('hidden')
            }
            controller.readingUnitGroupTarget.classList.remove('hidden')
            controller.readingUnitNoticeTarget.classList.remove('hidden')
          }
          else {
            controller.tokenIdTarget.value = ''
            controller.newDeviceNumberNoticeTarget.classList.add('hidden')
            controller.readingUnitNoticeTarget.classList.add('hidden')
            if (controller.hasFlxInputNoticeTarget) {
              controller.flxInputNoticeTarget.classList.add('hidden')
            }
          }
        }
      })

      return;
    }

    const inputParam = checkFlxInput ? `&input=${this.flxInputValue()}` : '';

    $.ajax({
      url: `/assembly_protocols/load_token.json`,
      type: 'get',
      data: `reading_unit=${this.readingUnitTarget.value}&user_id=${this.nomUserIdTarget.value}&device_id=${this.nomDeviceIdValue()}${inputParam}`,
      success: function (response) {
        controller.toggleFlxConfiguration(response.flx_token)
        controller.tokenIdTarget.value = response.token_id
        if (response.not_available && response.flx_token) {
          controller.flxInputNoticeTarget.classList.remove('hidden')
          controller.readingUnitNoticeTarget.classList.add('hidden')
        }
        else if (response.token_id && response.token_id !== '') {
          controller.flxInputNoticeTarget.classList.add('hidden')
          controller.readingUnitNoticeTarget.classList.add('hidden')
        }
        else if (controller.readingUnitTarget.value !== '') {
          controller.readingUnitNoticeTarget.classList.remove('hidden')
        }
      }
    })
  }

  reloadMeterTypes() {
    const controller = this;

    $.ajax({
      // url: `/assembly_protocols/user_unpaired_devices.json`,
      url: `/assembly_protocols/load_meter_types.json`,
      type: 'get',
      data: `manufacturer_id=${this.manufacturerSelectTarget.value}`,
      success: function (response) {
        controller.refreshSelectValues(controller.meterTypeSelectTarget, response)
        controller.refreshSelectValues(controller.meterFlowSelectTarget, [])
      }
    })
  }

  reloadMeterFlows() {
    const controller = this;

    $.ajax({
      // url: `/assembly_protocols/user_unpaired_devices.json`,
      url: `/assembly_protocols/load_meter_flows.json`,
      type: 'get',
      data: `meter_type_id=${this.meterTypeSelectTarget.value}`,
      success: function (response) {
        controller.refreshSelectValues(controller.meterFlowSelectTarget, response)
      }
    })
  }

  refreshSelectValues(target, data) {
    target.innerHTML = "";

    const option = document.createElement("option");
    option.innerHTML = "----";
    target.appendChild(option);

    data.forEach((item) => {
      const option = document.createElement("option");
      option.value = item.id;
      option.innerHTML = item.name;
      target.appendChild(option);
    });
  }

  oldPhotoPreview() {
    let controller = this;
    let files = this.oldPhotoInputTarget.files

    const file = files[0];
    if (file) {
      controller.enablePhotoLoading(controller.oldPhotoLoadingTarget)

      const formData = new FormData(); // Create a new FormData object
      formData.append('old_device_photo', file);

      const picture_upload = $.ajax({
        url: '/assembly_protocols/' + this.protocolIdTarget.value + '/upload_photo',
        method: 'PATCH',
        contentType: false,
        processData: false,
        data: formData,
        // enctype: 'multipart/form-data',
        timeout: 60000,
        success: function(data, textStatus, jqXHR) {
          controller.disablePhotoLoading(controller.oldPhotoLoadingTarget);

          let reader = new FileReader()
          reader.onload = function() {
            controller.oldPhotoPreviewTarget.src = reader.result
            controller.oldPhotoPreviewTarget.classList.remove('hidden')
          }
          reader.readAsDataURL(file)
        },
        error: function(jqXHR, textStatus, errorThrown) {
          controller.disablePhotoLoading(controller.oldPhotoLoadingTarget);
        }
      });

      const abortButton = document.getElementById('old-photo-abort');
      abortButton.addEventListener('click', () => {
        picture_upload.abort()
      });
    }
  }

  newPhotoPreview() {
    let controller = this;
    let files = this.newPhotoInputTarget.files

    const file = files[0];
    if (file) {
      controller.enablePhotoLoading(controller.newPhotoLoadingTarget)

      const formData = new FormData(); // Create a new FormData object
      formData.append('new_device_photo', file);

      const picture_upload = $.ajax({
        url: '/assembly_protocols/' + this.protocolIdTarget.value + '/upload_photo',
        method: 'PATCH',
        contentType: false,
        processData: false,
        data: formData,
        // enctype: 'multipart/form-data',
        timeout: 60000,
        success: function(data, textStatus, jqXHR) {
          controller.disablePhotoLoading(controller.newPhotoLoadingTarget)

          let reader = new FileReader()
          reader.onload = function() {
            controller.newPhotoPreviewTarget.src = reader.result
            controller.newPhotoPreviewTarget.classList.remove('hidden')

          }
          reader.readAsDataURL(file)
        },
        error: function(jqXHR, textStatus, errorThrown) {
          controller.disablePhotoLoading(controller.newPhotoLoadingTarget)
        }
      });

      const abortButton = document.getElementById('new-photo-abort');
      abortButton.addEventListener('click', () => {
        picture_upload.abort()
      });
    }
  }

  enablePhotoLoading(target) {
    const buttons = document.querySelectorAll('.submit-protocol');
    buttons.forEach(button => {
      button.disabled = true;
    });

    target.classList.remove('hidden')
  }

  disablePhotoLoading(target) {
    const buttons = document.querySelectorAll('.submit-protocol');
    buttons.forEach(button => {
      button.disabled = false;
    });

    target.classList.add('hidden')
  }

  toggleWmbus() {
    if (this.wmbusCheckboxTarget.checked) {
      this.rtxGroupsTarget.classList.remove('hidden')
      document.querySelector('label[for="radio_wmbus"]').click();
    }
    else {
      this.rtxGroupsTarget.classList.add('hidden')
    }
  }

  select2init() {
    const controller = this;
    window.addEventListener('turbolinks:load', () => {
      const select = $('.select2submit').select2({
        tags: true,
        tokenSeparators: [',', ' ']
      });
      select.on("change", function (e) {
        controller.reloadDevices();
      });
    })
  };

  initializeFileInputs() {
    var fileInputs = document.querySelectorAll('.file-input');

    fileInputs.forEach(function(fileInput) {
      var label = document.createElement('label');
      label.className = 'custom-file-label';
      label.textContent = 'Vybrat soubor';

      var container = document.createElement('div');
      container.className = 'file-input-container';
      fileInput.parentNode.insertBefore(container, fileInput);
      container.appendChild(fileInput);
      container.appendChild(label);

      label.addEventListener('click', function() {
        fileInput.click();
      });
    });
  };

  tookOverNotPresent() {
    this.tookOverNameTarget.value = this.tookOverNotPresentButtonTarget.innerText;
    this.tookOverNotPresentButtonTarget.classList.add('hidden');
  }

  loadGps(e) {
    e.preventDefault();

    const controller = this;

    navigator.geolocation.getCurrentPosition(
      function(position) {
        controller.latitudeTarget.value = position.coords.latitude;
        controller.longitudeTarget.value = position.coords.longitude;
      },
      function(error) {
        alert(error.message)
        console.error('Error Code = ' + error.code + ' - ' + error.message);
      }
    );
  }

  toggleCustomEmailCheckbox() {
    if (this.customEmailCheckboxTarget.checked) {
      this.customEmailTarget.classList.remove('hidden')
    }
    else {
      this.customEmailTarget.classList.add('hidden')
      this.customEmailTarget.value = ''
    }
  }

  toggleResolver(event) {
    if (event.target.value === 'company') {
      this.userSelectTarget.classList.add('hidden')
      this.companySelectTarget.classList.remove('hidden')
      this.userSelectTarget.value = '';
      this.userSelectTarget.selectedIndex = 0;
    }
    else {
      this.userSelectTarget.classList.remove('hidden')
      this.companySelectTarget.classList.add('hidden')
      this.companySelectTarget.value = '';
      this.companySelectTarget.selectedIndex = 0;
    }
  }

  toggleDeviceList(event) {
    const userId = document.querySelector('#assembly_protocol_nom_user_id').value;
    const swapUnit = event.target.value;

    $.ajax({
      url: `/assembly_protocols/user_unpaired_devices`,
      type: 'get',
      data: `nom_user_id=${userId}&swap_unit=${swapUnit}`,
      success: function (response) {
        document.querySelector('#devices-accordion').innerHTML = response;
      }
    })
  }
}
